import React from 'react';
import { withStyles, Grid, Typography, } from '../../../material-ui';
import PropTypes from 'prop-types';

class BasketTextItem extends React.Component {

    render() {
        const { classes, time, title, teamName, score } = this.props;
        return (
            <Grid container direction='row' alignItems='center' style={{ width: '100%' }}>
                <Grid container alignItems='center' justifyContent='center' style={{ width: 50 }}>
                    <Typography style={{ color: '#878787', fontSize: 9, marginRight: 4, maxWidth: 30, marginBottom: 16 }}>{time}</Typography>
                </Grid>
                <Grid container direction='column' alignItems='center' justifyContent='center' style={{ width: 4 }}>
                    <Grid style={{ backgroundColor: '#D5D5D5', width: 1, height: 20 }}></Grid>
                    <Grid style={{ backgroundColor: '#D5D5D5', width: 4, height: 4, borderRadius: 2 }}></Grid>
                    <Grid style={{ backgroundColor: '#D5D5D5', width: 1, height: 40 }}></Grid>
                </Grid>
                <Grid container direction='column' style={{ flex: 1, maxWidth: 'calc(100vw - 120px)' }}>
                    <Typography style={{ color: '#878787', fontSize: 9, marginLeft: 4, maxWidth: 'calc(100vw - 120px)' }} >{teamName}</Typography>
                    <Typography style={{ color: '#0D0D0D', fontSize: 12, marginLeft: 4, maxWidth: 'calc(100vw - 120px)' }} >{title}</Typography>
                </Grid>
                <Grid container direction='column' alignItems='center' justifyContent='flex-end' style={{ width: 60, position: 'absolute', right: 0 }}>
                    <Typography style={{ color: '#0D0D0D', fontSize: 12, marginTop: 4 }}>{score}</Typography>
                </Grid>
            </Grid>
        );
    }
}

BasketTextItem.propTypes = {
    time: PropTypes.string,
    title: PropTypes.string,
    teamName: PropTypes.string,
    score: PropTypes.string,
}

export default withStyles((theme) => ({
    circleBack: {
        border: 'solid 4px #FC2D33',
        borderRadius: 20,
        height: 40,
        width: 40,
    },
}))(BasketTextItem);